import styled from 'styled-components';

import {ms} from '../../../../styles';
import {View} from '../../../../uikit/View';
import {MODAL_CLASS_NAMES} from '../../constants';

export const Container = styled(View).attrs({
  className: MODAL_CLASS_NAMES.body,
})<{modalPadding: number}>`
  flex-direction: column;
  flex-grow: 1;
  padding-inline: ${p => ms(p.modalPadding)};
`;

export const Scroll = styled(View).attrs({
  className: MODAL_CLASS_NAMES.scrollContainer,
})`
  flex-direction: column;
  flex-grow: 1;
`;
